import Icon from 'vue-awesome/components/Icon'

Icon.register({
  airline_seat_individual_suite_sharp: {
    paths: [
      {
        d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm16-6H11v7H3V7H1v10h22V7z'
      }
    ],
    width: '24',
    height: '24'
  }
})
